module.exports = __webpack_public_path__ + "static/media/upload-image-icon.d4e387e9.png";